import { SxProps, Theme } from "@mui/material";

export const stepperContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",
  alignSelf: "stretch",
};

export const stepperTitle: SxProps<Theme> = {
  color: "#000",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "28px",
  fontWeight: 700,
  lineHeight: "normal",
  fontStyle: "normal",
  width: "100%",
  maxWidth: "720px",
};

export const stepperText: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  fontFamily: '"Roboto Condensed", sans-serif',
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "normal",
};

export const stepIndicatorCircle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "24px",
  height: "24px",
  fontSize: "16px",
  fontWeight: 400,
  color: "#000",
  background: "var(--primary-main-f-7-b-500, #F7B500)",
  borderRadius: "50%",
  padding: "0px 7px",
};

export const stepIndicatorImg: SxProps<Theme> = {
  width: "16px",
  height: "16px",
};

export const stepTrackerContainer: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "16px",
  width: "100%",
};
export const stepTrackerLine: SxProps<Theme> = {
  display: "flex",
  flex: "1 0 0",
  height: "1px",
  backgroundColor: "var(--Grey-400, #BDBDBD)",
  alignSelf: "center",
  gap: "8px",
};
